export default {
  price: {
    id: 'landing_price_filter_title',
    defaultMessage: 'Price',
  },
}
